module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"views":{"contents":{"webcasts":{"meta_tags":{"description":"Erfolgsstories miterleben, komplexe Themen verstehen, Events hautnah - Entdecken Sie die CAPinside Webinare","title":"Vergangene Webinare"},"teaser":"Sie haben ein Webinar verpasst? Kein Problem. Hier finden Sie alle Aufzeichnungen unserer Online-Veranstaltungen.","title":"Vergangene Webinare"}}}}}}')
  delete Component.options._Ctor
}
